import { t } from "i18next";
import ButtonIcon from "../../common/buttonIcon";
import ButtonSubmit from "../../common/buttonSubmit";
import ButtonWhite from "../../common/buttonWhite";
import Moment from 'react-moment';
import moment from "moment"
import { useEffect, useState } from "react";
import TitleModal from "../../common/titleModal";
import InputFiledIcon from "../../inputFiledIcon";
import InputFiled from "../../common/inputFiled";
import { useAppDispatch } from "../../../redux";
import { forceTimeslotUpdate, updateTimeslot } from "../../../redux/reducer/timeslotReducer";
import ErrorMessageBox from "../../common/errorMessageBox";
import { useSelector } from "react-redux";
import AlertMessage from "../../alertMessage";

const EditTimeslot = (props: any) => {
  const dispatch = useAppDispatch();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  let showPopUpManager = props.showPopUpManager ?? "";
  let event = props.event
  const isParent = props.isParent;

  const [maxAttendances, setMaxAttendances] = useState(1);
  const [startDate, setStartDate] = useState(moment(event?.start).format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment(event?.end).format("YYYY-MM-DD"));
  const [startTime, setStartTime] = useState(moment(event?.start).format("HH:mm"));
  const [endTime, setEndTime] = useState(moment(event?.end).format("HH:mm"));
  const [errorMessage, setErrorMessage] = useState("");
  const { rangEvent } = useSelector((state: any) => state.login);

  let startEvent = ((rangEvent.startDate) ? moment(rangEvent.startDate).format('YYYY-MM-DD') : undefined);
  let endEvent = ((rangEvent.endDate) ? moment(rangEvent.endDate).format('YYYY-MM-DD') : undefined);

  useEffect(() => {
    if (event) {
      setMaxAttendances(event?.maximumAttendances);
      setStartDate(moment(event?.start).format("YYYY-MM-DD"))
      setEndDate(moment(event?.end).format("YYYY-MM-DD"))
      setStartTime(moment(event?.start).format("HH:mm"))
      setEndTime(moment(event?.end).format("HH:mm"))
    }
  }, [event]);


  const editTimeslot = async () => {
    setErrorMessage("");
    let object: any = {};
    object.category = event?.categoryId;
    if (maxAttendances < 1) {
      setErrorMessage(t('error.max-attendance-minor-0'));
      return
    }

    object.maximumAttendances = maxAttendances;
    if (new Date(endDate + ' ' + endTime) < new Date(startDate + ' ' + startTime)) {
      setErrorMessage(t('error.date-start-greater-data-end'));
      return
    }

    object.endDate = new Date(endDate + ' ' + endTime).toString();
    object.startDate = new Date(startDate + ' ' + startTime).toString();
    object.timezone = timezone;
    let response = await dispatch(updateTimeslot(object, event._id));
    if (response.status == 200) {
      console.log(response.data);
      props.closePopUp();
      props.changeMessagesuccess(response.data.result)

      if (typeof props.onSave === 'function') {
        props.onSave()
      }
      dispatch(forceTimeslotUpdate())
    }
    else {
      setErrorMessage(t(`error.${response.data?.result?.key}`));
      console.log("Data Error", response.data);
    }
  }

  const closePopUp = () => {
    props.closePopUp();
    setMaxAttendances(event?.maximumAttendances);
    setStartDate(moment(event?.start).format("YYYY-MM-DD"))
    setEndDate(moment(event?.end).format("YYYY-MM-DD"))
    setStartTime(moment(event?.start).format("HH:mm"))
    setEndTime(moment(event?.end).format("HH:mm"))
  }
  return (
    <>
      <div className={`ModalTimeslot ViewTimeslot ${((showPopUpManager == "Edit") ? 'active' : '')}`}>
        <div className="header">
          <div className="row ">
            <div className="col-10">
              <h6>{t('popup-edit-service.label-edit') as string}</h6>
              <h6><b><Moment format="LL">{event?.start}</Moment>  </b></h6>
              <h6><Moment format="HH:mm">{event?.start}</Moment> - <Moment format="HH:mm">{event?.end}</Moment></h6>
            </div>
            <div className="col-2 text-right">
              <ButtonIcon handleClick={closePopUp} icon="close" />
            </div>
          </div>
        </div>
        <div className="body">
          <div className="row">
            {isParent &&
              <div className="col-lg-12">
                <AlertMessage description={t('timeslot.linked-parent-edit-message')} />
              </div>
            }
            <div className="col-lg-12">
              <h6>{t('from') as String}</h6>
            </div>
            <div className="col-lg-6">
              <InputFiled type="date" min={startEvent} max={endEvent} handleChange={setStartDate} value={startDate} name="numberWaitTime" />
            </div>
            <div className="col-lg-6">
              <InputFiled type="time" handleChange={setStartTime} value={startTime} name="numberWaitTime" />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-lg-12">
              <h6>{t('to') as String}</h6>
            </div>
            <div className="col-lg-6 mb-4">

              <InputFiled type="date" min={startEvent} max={endEvent} handleChange={setEndDate} value={endDate} name="numberWaitTime" />
            </div>
            <div className="col-lg-6">
              <InputFiled type="time" handleChange={setEndTime} value={endTime} name="numberWaitTime" />
            </div>
          </div>
          <TitleModal title={t('label-max-attendnace')} />
          <InputFiledIcon min="1" type="number" name="numberMaxAttendnace" handleChange={setMaxAttendances} value={maxAttendances} icon="boy" />
          <ErrorMessageBox errorMessage={errorMessage} />
        </div>
        <div className="footer">
          <div className="row">
            <div className="col-lg-12 text-lg-right p-2">
              <ButtonWhite handleChange={closePopUp} textButton={t('cancel')} />
              <ButtonSubmit textButton={t('edit')} handleChange={editTimeslot} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default EditTimeslot